import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FeedbackSettingAddComponent from '../components/feedbackSettingAddComponent'; 
import { insertQuestionDetailsSettings ,fetchQuestionType,fetchEmoji, fetchFeedbackTypes
     }from '../action/feedbackSettingAction';

class feedbackSettingAddContainer extends Component {
    constructor(props) {
        super(props);
        this.insertQuestionDetailsSettings = this.insertQuestionDetailsSettings.bind(this); 
    }

    componentDidMount() {  
        this.props.actions.fetchQuestionType( 
            this.props.dispatch
        ) 
        this.props.actions.fetchEmoji( 
            this.props.dispatch
        ) 
        this.props.actions.fetchFeedbackTypes( 
            this.props.dispatch
        )
    }

    insertQuestionDetailsSettings(formData) { 
        this.props.actions.insertQuestionDetailsSettings(
            this.props.feedbackSettings.isLoading,
            formData,
            this.props.dispatch
        )
        
    }
 
    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row"> 
                            <FeedbackSettingAddComponent                                 
                                insertQuestionDetailsSettings={this.insertQuestionDetailsSettings} 
                                feedbackSettings={this.props.feedbackSettings} 
                                statusCode={this.props.feedbackSettings.statusCode} 
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            insertQuestionDetailsSettings ,fetchQuestionType,
            fetchEmoji,
            fetchFeedbackTypes
        }, dispatch)
    };
};

function mapStateToProps({ feedbackSettingReducer }) { 
    return {  
        feedbackSettings: {
            isLoading: feedbackSettingReducer.isLoading,
            emojiImage:feedbackSettingReducer.emojiImage,
            questionType: feedbackSettingReducer.questionType,
            questionList: feedbackSettingReducer.questionList,
            statusCode: feedbackSettingReducer.statusCode,
            errorMessage: feedbackSettingReducer.errorMessage,
            messageLabel: feedbackSettingReducer.messageLabel,
            FeedbackTypesList : feedbackSettingReducer.FeedbackTypesList,
        } 
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(feedbackSettingAddContainer))